import React from 'react';
import './OfficeBearers.css';

const officeBearers = [
  { 
    name: 'Hemant Takle',
    post: 'President, NAB India',
    image: '/images/hemant-takle.png'
  },
  { 
    name: 'Dr. Vimal Kumar Dengla',
    post: 'Hon. Secretary General, NAB India',
    image: '/images/vimal-dengla.png'
  },
  { 
    name: 'Dr. Arun Kumar Sharma',
    post: 'Vice President, NAB India',
    image: '/images/arun-sharma.jpeg'
  },
  { 
    name: 'Hem Singh Yadav',
    post: 'Vice President, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Namarata Kanodia',
    post: 'Vice President, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Rameshwar Badrinarayan Kalantri',
    post: 'Vice President, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Sanjay Kumar Rai',
    post: 'Vice President, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Anil Mittal',
    post: 'Hon. Secretary, NAB India',
    image: '/images/anil-mittal.jpeg'
  },
  { 
    name: 'Behroz Mulla',
    post: 'Hon. Secretary, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Gopal Krishna Agarwal',
    post: 'Hon. Secretary, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Shailendra Jain',
    post: 'Hon. Secretary, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Yusufi F. Kapadia',
    post: 'Hon. Secretary, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Hari Shanker Singh',
    post: 'Hon. Treasurer, NAB India',
    image: '/images/Harikrishna.jpeg'
  },
  { 
    name: 'Ramakant T. Satam',
    post: 'Hon. Treasurer, NAB India',
    image: '/images/ramakant-satam.jpeg'
  },
  { 
    name: 'Anirudh Prasad Paswan',
    post: 'E.C Member, NAB India',
    image: '/images/anirudh-paswan.jpeg'
  },
  { 
    name: 'Deepak Kumar Rawal',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Jaiprakash Nishad',
    post: 'E.C Member, NAB India',
    image: '/images/jayprakash.jpeg'
  },
  { 
    name: 'Jayantibhai Patel',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Jitendra Kumar Purohit',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Kayamuddin Khan',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Prashant Pathak',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Priyanka Singh',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Sant Bali Chaudhary',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Shobhaben Bharatbhai Khatri',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Suryabhan Panditrao Salunkhe',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Rananjay Kumar Singh',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Vijay R. Kajrolkar',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Vijay Rathi',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  },
  { 
    name: 'Yasmin Jal Siganporia',
    post: 'E.C Member, NAB India',
    image: '/images/default.png'
  }
];

const OfficeBearers = () => {
  return (
    <section className="office-bearers" aria-labelledby="office-bearers-heading">
      <h2 id="office-bearers-heading">Chief Office Bearers</h2>
      <div className="bearers-grid">
        {officeBearers.map((bearer, index) => (
          <div key={index} className="bearer-card">
            <img src={bearer.image} alt={`${bearer.name}, ${bearer.post}`} />
            <h3>{bearer.name}</h3>
            <p className="post">{bearer.post}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default OfficeBearers;
